
    import { defineComponent } from 'vue'
    import { iInputVariable } from '../../FunctionsCatalog'
    import Card from 'primevue/card'
    import FunctionsCatalogInputVariable from './FunctionsCatalogInputVariable.vue'

    export default defineComponent({
        name: 'function-catalog-input-columns-card',
        components: { Card, FunctionsCatalogInputVariable },
        props: { variables: { type: Array }, readonly: { type: Boolean } },
        data() {
            return {
                inputVariables: [] as iInputVariable[]
            }
        },
        created() {
            this.loadInputVariables()
        },
        methods: {
            loadInputVariables() {
                this.inputVariables = this.variables as iInputVariable[]
            },
            addInputVariable() {
                this.inputVariables.push({ name: '', type: '', value: '' })
            },
            deleteInputVariable(index: number) {
                this.inputVariables.splice(index, 1)
            }
        }
    })
